module.exports = __webpack_public_path__ + "media/src/images/joining_on-5c4fd61afbb39f222788ebcc56b54138.png";